import { AfterViewInit, Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { TableVirtualScrollDataSource } from 'ng-table-virtual-scroll';

// models
import { IEditableTable, IEditableTableColumn, IEditCellEvent } from './models';

// services
import { Utils } from '../../services/utils.service';

import { SHARED_MODULES } from '../../../shared.';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { TableVirtualScrollModule } from 'ng-table-virtual-scroll';
import { MeasurementUnitPipe } from '../../pipes/measurement-unit.pipe';
import { MeasurementUnitTranslatePipe } from '../../pipes/measurement-unit-translate.pipe';
import { PhIconWrapperComponent } from '../ph-icon-wrapper/ph-icon-wrapper.component';

@Component({
    selector: 'app-ph-editable-table',
    templateUrl: './ph-editable-table.component.html',
    styleUrls: ['./ph-editable-table.component.scss'],
	imports: [
		SHARED_MODULES,
		ScrollingModule,
		TableVirtualScrollModule,
		MeasurementUnitPipe,
		MeasurementUnitTranslatePipe,
		PhIconWrapperComponent
	],
    standalone: true
})
export class PhEditableTableComponent implements AfterViewInit {

	columns: Array<IEditableTableColumn> = [];
	displayColumns: Array<string>;
	tableData: TableVirtualScrollDataSource<any>;

	@Input('deleteTitle') deleteTitle: string = '';
	@Input('dataSource') set dataSource(data: IEditableTable) {
		this.columns = data.columns;
		this.displayColumns = [...this.columns.map((column: IEditableTableColumn) => column.key), 'options'];
		this.tableData = new TableVirtualScrollDataSource(data.dataSource);
		if (this.sort) this.tableData.sort = this.sort;
	}

	@Output('cellEdit') cellEditEmitter: EventEmitter<IEditCellEvent> = new EventEmitter<IEditCellEvent>();
	@Output('cellDelete') cellDeleteEmitter: EventEmitter<string> = new EventEmitter<string>();

	@ViewChild(MatSort) sort: MatSort;
	@ViewChild('tableContainer') tableContainer: ElementRef;

	constructor() {}

	ngAfterViewInit(): void {
		this.tableData.sort = this.sort;
	}

	cellEdit(event: Event, column: IEditableTableColumn, id: string, columnIndex: number): void {
		if (!event?.target) return;
		let value = (event.target as any).value;
		if (column.dtype === 'number') {
			if (!Utils.isNullOrUndefined(value) && (!column.min_value || value >= column.min_value)) {
				value = Utils.round(Number(value));
			} else {
				value = null;
			}
		}
		(event.target as HTMLInputElement).value = value;
		this.cellEditEmitter.emit({
			id: id,
			key: column.key,
			value: value,
			columnIndex: columnIndex
		});
	}

	deleteRow(id: string): void {
		this.cellDeleteEmitter.emit(id);
	}

	numberInputValidate(event: KeyboardEvent): boolean {
		const blockedSymbols: Array<string> = ['e', 'E', '-', '+'];
		return !blockedSymbols.includes(event.key);
	}

	scrollToErrorColumn(index: number): void {
		const invalidColumns: HTMLCollection = this.tableContainer.nativeElement.getElementsByClassName('mat-mdc-cell error');
		if (!invalidColumns.length) return;

		invalidColumns[index].scrollIntoView({ behavior: 'smooth', block: 'center' });
		invalidColumns[index].getElementsByTagName('input')?.[0]?.focus();
	}
}
